import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPreReqsByIctId } from "../../../../../store/ictPreReqSlice";
import { fetchFaqsByIctId } from "../../../../../store/ictFaqSlice";
import { fetchICTData } from "../../../../../store/uiSlice";
import { fetchRelatedByIctId } from "../../../../../store/ictRelatedSlice";

import PreReqPopup from "./PreReq";
import IctFaq from "./IctFaq";
import RelatedIct from "./RelatedIct";
import RelatedIctDomain from "./RelatedIctDomain";
import IctBrochure from "./IctBrochure";

const IctCatalog = () => {
  const { ictId } = useParams();
  const dispatch = useDispatch();

  const [showPrereq, setShowPrereq] = useState(false);
  const [showAddPrereq, setShowAddPrereq] = useState(false);
  const [showFaq, setShowFaq] = useState(false);
  const [showAddFaq, setShowAddFaq] = useState(false);
  const [showRelated, setShowRelated] = useState(false);
  const [showAddRelated, setShowAddRelated] = useState(false);
  const [showRelatedDomain, setShowRelatedDomain] = useState(false);
  const [showAddRelatedDomain, setShowAddRelatedDomain] = useState(false);
  const [showBrochure, setShowBrochure] = useState(false);
  const [showAddBrochure, setShowAddBrochure] = useState(false);


  const sanitizeUrl = (url) => url.replace(/([^:])\/\//g, "$1/");

  const { preReqs = [], loading: preReqLoading, error: preReqError } = useSelector(
    (state) => state.ictPreReq || {}
  );
  const { faqs = [], loading: faqLoading, error: faqError } = useSelector(
    (state) => state.ictFaq || {}
  );
  const {
    relatedIcts = [],
    loading: relatedLoading,
    error: relatedError,
  } = useSelector((state) => state.ictRelated || {});
  const { ictData = [], loading: ictLoading, error: ictError } = useSelector(
    (state) => state.ui || {}
  );

  const course = ictData.find((item) => String(item.id) === ictId);

  useEffect(() => {
    if (!ictData.length) dispatch(fetchICTData());
    if (ictId) {
      dispatch(fetchPreReqsByIctId(ictId));
      dispatch(fetchFaqsByIctId(ictId));
      dispatch(fetchRelatedByIctId(ictId));
    }
  }, [dispatch, ictId, ictData.length]);



  return (
    <div className="container course-catalog">
      <h2 className="section-title">Course Catalog</h2>

      {(ictLoading || preReqLoading || faqLoading) && <p>Loading course information...</p>}
      {(ictError || preReqError || faqError) && (
        <p className="error">
        </p>
      )}

      {course && (
        <div className="course-details-card">
          <div className="course-image">
            <img
              src={sanitizeUrl(`https://iteyonikservicesinstitute.com/${course.ictImg}`)}
              alt="ICT"
              className="ict-img"
              width="100%"
              height="auto"
            />
            {/* === Detail Control Tabs === */}
            <h3>Details Control Panel</h3>
            <div className="tab-section">

              {/* Prerequisite Controls */}
              <div className="tab-buttons">
                <span>Pre-requisites</span>
                <button className="update-btn smallBtn" onClick={() => setShowPrereq(true)}>
                  <i className="fas fa-file"></i>
                </button>
                <button className="delete-btn smallBtn" onClick={() => setShowAddPrereq(true)}>
                  <i className="fas fa-plus"></i>
                </button>
              </div>

              {/* FAQ Controls */}
              <div className="tab-buttons">
                <span>FAQs</span>
                <button className="update-btn smallBtn" onClick={() => setShowFaq(true)}>
                  <i className="fas fa-question-circle"></i>
                </button>
                <button className="delete-btn smallBtn" onClick={() => setShowAddFaq(true)}>
                  <i className="fas fa-plus"></i>
                </button>
              </div>
              {/* Related ICT Controls */}
              <div className="tab-buttons">
                <span>Related ICTs</span>
                <button
                  className="update-btn smallBtn"
                  onClick={() => setShowRelated(true)}
                >
                  <i className="fas fa-link"></i>
                </button>
                <button
                  className="delete-btn smallBtn"
                  onClick={() => setShowAddRelated(true)}
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
              <div className="tab-buttons">
                <span>Related Domains</span>
                <button className="update-btn smallBtn" onClick={() => setShowRelatedDomain(true)}>
                  <i className="fas fa-layer-group"></i>
                </button>
                <button className="delete-btn smallBtn" onClick={() => setShowAddRelatedDomain(true)}>
                  <i className="fas fa-plus"></i>
                </button>
              </div>
              <div className="tab-buttons">
                <span>Brochures</span>
                <button className="update-btn smallBtn" onClick={() => setShowBrochure(true)}>
                  <i className="fas fa-file-pdf"></i>
                </button>
                <button className="delete-btn smallBtn" onClick={() => setShowAddBrochure(true)}>
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>

            {/* === Popups === */}
            {showBrochure && (
              <IctBrochure
                ictId={ictId}
                onClose={() => setShowBrochure(false)}
              />
            )}
            {showAddBrochure && (
              <IctBrochure
                ictId={ictId}
                onClose={() => setShowAddBrochure(false)}
                showInsertForm={true}
              />
            )}

            {showPrereq && (
              <PreReqPopup
                ictId={ictId}
                preReqs={preReqs}
                onClose={() => setShowPrereq(false)}
              />
            )}
            {showAddPrereq && (
              <PreReqPopup
                ictId={ictId}
                onClose={() => setShowAddPrereq(false)}
                showInsertForm={true}
              />
            )}

            {showFaq && (
              <IctFaq
                ictId={ictId}
                onClose={() => setShowFaq(false)}
              />
            )}
            {showAddFaq && (
              <IctFaq
                ictId={ictId}
                onClose={() => setShowAddFaq(false)}
                showInsertForm={true}
              />
            )}
            {/* Related ICT */}
            {showRelated && (
              <RelatedIct
                ictId={ictId}
                onClose={() => setShowRelated(false)}
              />
            )}
            {showAddRelated && (
              <RelatedIct
                ictId={ictId}
                onClose={() => setShowAddRelated(false)}
                showInsertForm={true}
              />
            )}
            {showRelatedDomain && (
              <RelatedIctDomain ictId={ictId} onClose={() => setShowRelatedDomain(false)} />
            )}
            {showAddRelatedDomain && (
              <RelatedIctDomain ictId={ictId} onClose={() => setShowAddRelatedDomain(false)} showInsertForm />
            )}

          </div>

          <div className="course-info">
            <h3>{course.ictName}</h3>
            <p><strong>Type:</strong> {course.ictType}</p>
            <p><strong>Short Desc:</strong> {course.ictSDesc}</p>
            <p><strong>Description:</strong> {course.ictDesc}</p>
          </div>
        </div>
      )}
      <hr/>
    </div>
  );
};

export default IctCatalog;
